import { render, staticRenderFns } from "./SidePanelLoans.vue?vue&type=template&id=3ceccbc6"
import script from "./SidePanelLoans.vue?vue&type=script&lang=js"
export * from "./SidePanelLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports